<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout justify-space-around>
          <v-flex>
            <v-card class="main-card" flat>
              <v-flex>
                <v-responsive :aspect-ratio="16 / 9">
                  <v-card-title primary-title>
                    <div>
                      <div class="headline pl-2 pa-1">{{ $t("customers.addStaff.heading") }}</div>
                    </div>
                  </v-card-title>
                  <v-form ref="form" v-model="form" class="pa-4 pt-6">
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.first_name"
                        :rules="[rules.required]"
                        :label="$t('customers.addStaff.firstName')"
                        type="text"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.last_name"
                        :rules="[rules.required]"
                        :label="$t('customers.addStaff.lastName')"
                        type="text"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.username"
                        :rules="[rules.email]"
                        :label="$t('customers.addStaff.email')"
                        type="email"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.password"
                        :rules="[rules.password]"
                        :label="$t('customers.addStaff.password')"
                        type="password"
                      ></v-text-field
                    ></v-flex>
                    <v-flex>
                      <v-select
                        outline
                        v-model="model.gender"
                        :label="$t('customers.addStaff.gender')"
                        :items="gender"
                        dense
                      ></v-select
                    ></v-flex>
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.birthday"
                        :rules="[rules.required]"
                        :label="$t('customers.addStaff.dateOfBirth')"
                        type="date"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        outline
                        v-model="model.phone_number"
                        :rules="[rules.phoneNumber]"
                        :label="$t('customers.addStaff.phoneNumber')"
                        type="phone"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-select
                        v-model="model.roles"
                        :items="allRoles"
                        :label="$t('customers.addStaff.roles')"
                        multiple
                        outline
                      ></v-select>
                    </v-flex>
                  </v-form>
                </v-responsive>
              </v-flex>
            </v-card>
          </v-flex>
          <v-flex style="background-color: white">
            <v-card color="#fff" min-width="600" class="card" flat>
              <v-card-title primary-title class="card-title">
                <div>
                  <div class="headline pl-2 pa-1">{{ $t("customers.addStaff.documentInformation") }}</div>
                </div>
              </v-card-title>
              <v-flex xs12>
                <v-flex xs5>
                  <file-upload
                    class="docs"
                    @change="model.working_contract = $event"
                    :documentName="$t('customers.addStaff.workingContract')"
                  />
                </v-flex>
                <v-flex>
                  <file-upload
                    class="docs"
                    @change="model.IBAN = $event"
                    documentName="IBAN"
                  />
                  <v-flex xs5>
                    <file-upload
                      class="docs"
                      @change="model.pay_slip = $event"
                      :documentName="$t('customers.addStaff.paySlip')"
                    />
                  </v-flex>
                </v-flex>
              </v-flex>
              <v-flex xs12>
                <v-flex>
                  <file-upload
                    class="docs"
                    @change="model.planning = $event"
                    :documentName="$t('customers.addStaff.planning')"
                  />
                </v-flex>
              </v-flex>
              <v-btn
                :loading="loading"
                @click="addStaff"
                color="secondary"
                dark
                large
                class="btn"
                >{{ $t("common.create") }}</v-btn
              >
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<style>
.docs {
  margin-bottom: 12px;
  margin-right: 12px;
}
.btn {
  margin-top: 110px;
  margin-bottom: 20px;
  float: right;
  padding: 0px 65px;
  margin-right: 20px;
  z-index: 4;
}
.card {
  margin-right: 200px;
  padding-left: 35px;
}
.card-title {
  margin-left: -25px;
  margin-bottom: 25px;
}
.main-card {
  min-width: 500px;
  margin-left: 170px;
}
.footer {
  margin-top: 130px;
  margin-left: 4px;
}
</style>

<script>
import axios from "axios";
import FileUpload from "@/components/widgets/FileUpload.vue";

export default {
  title() {
    return this.$t("customers.addStaff.title");
  },
  components: { FileUpload },
  data: () => ({
    loading: false,
    error: false,
    file: "",
    roleItem: { id: "", name: "" },
    rolesList: [],
    model: {
      first_name: "",
      last_name: "",
      username: "",
      password: "",
      gender: "",
      birthday: "",
      phone_number: "",
      working_contract: "",
      IBAN: "",
      pay_slip: "",
      planning: "",
      roles: [],
    },
    allRoles: [],
    roleIds: [],
    email: undefined,
    form: false,
    isLoading: false,
  }),
  computed: {
    // "Male"/"Female" stay the values (compared in addStaff), only the text is translated
    gender() {
      return [
        { text: this.$t("customers.addStaff.male"), value: "Male" },
        { text: this.$t("customers.addStaff.female"), value: "Female" },
      ];
    },
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("customers.addStaff.validEmail"),
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("customers.addStaff.invalidLength", { length: len }),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) || this.$t("customers.addStaff.passwordLength"),
        phoneNumber: (v) =>
          // (!!v &&
          //   v.search(/^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/) !== -1) ||
          // "Not a valid phone number !",

          (!!v &&
            v.search(
              /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
            ) !== -1) ||
          this.$t("customers.addStaff.invalidPhone"),

        required: (v) => !!v || this.$t("customers.addStaff.requiredField"),
      };
    },
  },

  mounted() {
    axios.get(this.api.ACTIONS.ROLES).then((response) => {
      for (let i = 0; i < response.data.data.data.length; i++) {
        let roleItem = {};
        // console.log(response.data.data.data[i]);
        this.allRoles.push(response.data.data.data[i].name);
        roleItem.id = response.data.data.data[i].id;
        roleItem.name = response.data.data.data[i].name;
        this.rolesList.push(roleItem);
        // console.log(this.rolesList);
      }
    });
  },

  methods: {
    addStaff() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        this.model.gender = this.model.gender === "Male" ? 0 : 1;
        // console.log(this.model.gender);
        formData.append("gender", this.model.gender);
        formData.append("first_name", this.model.first_name);
        formData.append("last_name", this.model.last_name);
        formData.append("username", this.model.username);
        formData.append("password", this.model.password);
        formData.append("birthday", this.model.birthday);
        formData.append("phone_number", this.model.phone_number);
        formData.append("working_contract", this.model.working_contract);
        formData.append("IBAN", this.model.IBAN);
        formData.append("planning", this.model.planning);
        formData.append("pay_slip", this.model.pay_slip);
        // formData.append("roles", this.model.roles);

        this.roleIds = [];
        // this.model.roles.forEach((e) => {
        //   for (let i = 0; i < this.rolesList.length; i++) {
        //     if (this.rolesList[i].name === e)
        //       this.roleIds.push(this.rolesList[i].id);
        //   }
        // });
        // console.log(this.roleIds);
        // formData.append("roles[]", this.roleIds);

        this.model.roles.forEach((e) => {
          for (let i = 0; i < this.rolesList.length; i++) {
            if (this.rolesList[i].name === e)
              formData.append("roles[]", this.rolesList[i].id);
          }
          // console.log(this.model.roles);
        });
        // });

        this.loading = true;

        this.axios
          .post(this.api.ACTIONS.USERS, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("customers.addStaff.staffAdded"), "green");
            this.$router.push("/staff");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("customers.addStaff.checkInfo"), "red");
            }
          })
          .then(() => (this.loading = false));

        // console.log(this.model);
      }
    },
  },
};
</script>
